import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import {
  TextField,
  Row,
  Col,
  Accordion,
  Headline,
  IconButton,
} from '@folio/stripes/components';

const EditPasswordSection = ({
  expanded,
  onToggle,
  accordionId,
  disabled,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <Accordion
      open={expanded}
      id={accordionId}
      onToggle={onToggle}
      label={<Headline size="large" tag="h3"><FormattedMessage id="ui-users.information.password" /></Headline>}
    >
      <Row>
        <Col xs={12} md={6}>
          <Field
            label={<FormattedMessage id="ui-users.information.password" />}
            name="password"
            id="staff_password"
            component={TextField}
            type={showPassword ? 'text' : 'password'}
            fullWidth
            disabled={disabled}
            required
            endControl={
              <IconButton
                icon={showPassword ? 'eye-open' : 'eye-closed'}
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              />
            }
          />
        </Col>
        <Col xs={12} md={6}>
          <Field
            label={<FormattedMessage id="ui-users.information.confirmPassword" />}
            name="confirmPassword"
            id="staff_confirm_password"
            component={TextField}
            type={showConfirmPassword ? 'text' : 'password'}
            fullWidth
            disabled={disabled}
            required
            endControl={
              <IconButton
                icon={showConfirmPassword ? 'eye-open' : 'eye-closed'}
                onClick={toggleConfirmPasswordVisibility}
                aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
              />
            }
          />
        </Col>
      </Row>
    </Accordion>
  );
};

EditPasswordSection.propTypes = {
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
  accordionId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default EditPasswordSection;